import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { getDateOfDoc } from '../../../services/utils/pdf';

interface Props {
  doc: InvoiceInterface;
}

export const DocViewTitle = ({ doc }: Props) => {
  const { t } = useTranslation();

  const getDate = useCallback(() => {
    return getDateOfDoc(doc?.documentDate, doc?.sentToAadeAt);
  }, [doc?.documentDate, doc?.sentToAadeAt]);

  const getDeliveryNoteMark = useCallback(() => {
    if (doc?.isDeliveryNote) return ` - ${t('DOC_TYPES.DELIVERY_NOTE_SHORT')}`;
  }, [doc?.isDeliveryNote, t]);

  const getTransitLabel = useCallback(() => {
    const labels = [];
    if (doc?.nonObligatedRecipient) labels.push(t('FORMS.NON_OBLIGATED_RECIPIENT'));
    if (doc?.withoutDigitalTransportTracking) labels.push(t('FORMS.WITHOUT_DIGITAL_TRANSPORT_TRACKING'));

    const labelToShow = labels.join(' - ');

    if (labelToShow) {
      return <div className="normalText0 m-l-2">{`(${labelToShow})`}</div>;
    }
  }, [doc?.nonObligatedRecipient, doc?.withoutDigitalTransportTracking, t]);

  return (
    <div className="flex-space-between-start-row-nowrap">
      <div className="flex-start-start-column-nowrap width400">
        <div className="boldText1">{t('PDF.DOC_TYPE')}</div>
        <div className="flex-start-start-row-wrap">
          <div className="normalText2">
            {t(`DOC_TYPES.${doc?.documentType?.name}`)}
            {getDeliveryNoteMark()}
          </div>
          {getTransitLabel()}
        </div>
      </div>

      <div className="flex-center-center-column-nowrap width400">
        <div className="boldText1">
          {t('PDF.SERIES')} - {t('PDF.SERIAL_NUMBER')}
        </div>
        <div className="flex-center-center-row-wrap">
          <div className="normalText2">
            {doc?.seriesName || '0'} - {doc?.serialNumber || 'empty'}
          </div>
        </div>
      </div>

      <div className="flex-center-end-column-nowrap width400">
        <div className="boldText1">{t('PDF.DATE')}</div>
        <div className="normalText2">{getDate()}</div>
      </div>
    </div>
  );
};
